// extracted by mini-css-extract-plugin
export default {"warehouse_card":"styles_warehouse_card__IGJ03"};